import React, { useContext } from "react";
import Modal from "../components/Modal/Modal";
import ictHub from "./../images/p5iowqrw 1.png";
import massChallenge from "./../images/def1r55m 1.png";
import kondo from "./../images/gfr 1.png";
import subtract from "./../images/Subtract.png";
import urbanShelter from "./../images/index 1.png";
import { LogContent } from "../helper/context";
import { useAuth } from "../helper/auth";
import SEO from "../components/Seo/Seo";
import Navbar from "../components/HomeComponents/Navbar";

function About() {
  const auth = useAuth();
  const { displayMeta } = useContext(LogContent);
  return (
    <>
      <div>
        <SEO title="About Paywater" type="article" />
        <div>
          <Navbar />
          <div className="bg-[#F3F5F9] lg:mt-2 border lg:mx-auto pb-20">
            <h2 className="pt-10 lg:pt-20 font-semibold text-3xl text-center">
              About Us
            </h2>
            <p className="mt-8 px-2 lg:mt-9 text-[17px] font-medium text-[#979797] text-justify w-[360px] lg:w-[800px] tracking-[-0.02em] leading-8 mx-auto">
              <span className="block mb-4">
                Hydronamics Limited provides solutions to support water
                utilities, water consumers and other stakeholders in the water
                provision ecosystem. Our goal is to facilitate improved water
                production, water management infrastructure and revenue
                generation through-deployment of cutting-edge technologies. We
                are poised to become Nigeria’s most innovative and reliable
                supplier of efficient and sustainable water technology
                solutions. Our offerings include smart water metering solutions,
                mobile and cloud software, and data analytics for both water
                consumers and utilities alike.
              </span>
              <span className="block mb-4">
                Hydronamics combines the expertise of ideation and problem
                solving which we channel into the design and development of our
                products. As we continue to disrupt the water industry. The
                benefits of our solution include digitization, easy and
                streamlined service delivery, processes that slash operational
                costs, and tools for improved revenue generation. Our digital
                systems bring together the water consumer and the utility under
                a unified platform to more efficiently and profitably serve the
                community.
              </span>
              <span className="block mb-4">
                We maintain a close relationship with our consumers and as such
                are keen on user-centered design and development, which takes
                full cognizance of our customer's pains and realities. These
                factors are reflected painstakingly in the products and
                applications we deploy, so that improved customer satisfaction
                leads to rapid adoption and subsequent rapid revenue growth.
              </span>
              <span className="block mb-4">
                To a great extent, Hydronamics is a for-profit company, but we
                are also keen about impact. Our long-term vision is to empower
                water utilities - through improved revenue generation - to
                maintain and expand their services and infrastructure to
                underserved areas, thereby reducing to the barest minimum the
                trend of incessant drilling of boreholes. By design, the social,
                environmental and economic values created by Hydronamics are
                meticulously tracked and analyzed for improved service delivery,
                accountability, and return on investment.
              </span>
            </p>
            <div className="flex flex-col space-y-5 justify-center items-center pb-36 lg:hidden">
              <img
                className="mr-4 w-14 h-9 object-contain"
                src={ictHub}
                alt=""
              />
              <img
                className="mr-4 w-14 h-9 object-contain"
                src={massChallenge}
                alt=""
              />
              <img
                className="mr-4 w-14 h-9 object-contain"
                src={kondo}
                alt=""
              />
              <img
                className="mr-4 w-14 h-9 object-contain"
                src={subtract}
                alt=""
              />
              <img
                className="w-14 h-9 object-contain"
                src={urbanShelter}
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      {displayMeta && auth.user && <Modal />}
    </>
  );
}

export default About;
